import {
  Image as SitecoreImage,
  ImageField,
  ImageFieldValue,
} from '@sitecore-jss/sitecore-jss-nextjs';
import omit from 'lodash-es/omit';
import Image from 'next/image';

interface BackgroundImageProps {
  field?: ImageField | ImageFieldValue;
  externalField?: {
    src?: string;
    altText?: string;
  };
  cardType: 'big' | 'small';
}

export const BackgroundImage = ({ field, externalField, cardType }: BackgroundImageProps) => {
  const style: React.CSSProperties =
    cardType === 'big'
      ? {
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          width: '100%',
          minWidth: '100%',
          height: '100%',
          objectFit: 'cover',
        }
      : {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        };

  const renderingSizeProps = cardType === 'big' ? { fill: true } : { width: 400, height: 400 };
  return !!field?.value && !!Object.keys(field.value).length ? (
    <SitecoreImage field={field} {...omit(renderingSizeProps, 'fill')} style={style} />
  ) : !!externalField && !!Object.keys(externalField).length ? (
    <Image
      src={externalField.src || ''}
      alt={externalField.altText || ''}
      {...renderingSizeProps}
      style={style}
    />
  ) : null;
};
